// @ts-ignore
import punycode from "punycode/";

const isDomainNameValid = (domainName = ""): boolean => {
  if (domainName === "") {
    return true;
  }

  // To allow IDNs (Internationalized Domain Names) - used the punycode library (https://github.com/mathiasbynens/punycode.js) to convert the domain name from Unicode to ASCII - so that all urls are in ASCII format.
  // Eg: mañana.com to xn--maana-pta.com (UNICODE to ASCII)
  const asciiDomainName = punycode.toASCII(domainName);

  const domainNameRegex =
    /^(?:(?:https?|ftp):\/\/)?[A-Za-z0-9-]{1,63}(\.[A-Za-z0-9-]{1,63})*\.[A-Za-z]{2,}$/;

  if (!domainNameRegex.test(asciiDomainName)) return false;

  const labels = domainName.split(".");
  for (const label of labels) {
    if (label.startsWith("-") || label.endsWith("-")) return false;
  }

  return true;
};

export { isDomainNameValid };
